export const INFO_TOAST_KEY = 'infoToast';
export const ERROR_TOAST_KEY = 'errorToast';
